import script from "./GeminiChatbot.vue?vue&type=script&setup=true&lang=js"
export * from "./GeminiChatbot.vue?vue&type=script&setup=true&lang=js"

import "./GeminiChatbot.vue?vue&type=style&index=0&id=ffa810ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffa810ea"]])

export default __exports__